import axios from 'axios';
// import { getAppVersion, clearAppVersion, incrementBy, test, fetchAppVersion } from './about';
import { registration, dispatchClearRegistation } from './register'
import { login, dispatchClearLoginInfo } from './login'
import { dispatchClearOtp, verifyOtp } from './loginOtpVerify';
import { clearUserNameVerify, userNameVerify } from './userNameVerify';
import { dispatchClearRegistrationOtpVerify, verifyOtpForRegistration } from './registrationOtp'
import { getTestSeriesList, clearTestSeriesList } from './testSeries/getTestSeries';
import { getTestSeriesTestList, clearTestSeriesTestList } from './testSeries/getTestSeriesTestList';
import { getSingleTestInfo, clearSingleTestInfoData } from './getSingleTestDetails';
import { getTestTermsAndConditions, clearTestTermsAndConditionsData } from './testTermsAndConditions';
import { changePhoneNumber, clearChangePhoneNumber } from './changePhone';
import { lostPhone, clearLostPhone } from './lostPhone';


import {
  clearTest,
  setInitialStartTimeStamp,
  timeSpend,
  changeQuestion,
  selectedAnswers,
  getTest,
  markedQuestions,
} from './startTest';
import { submitTest, clearSubmitTestData } from './submitTest';
import { verifyEmail, clearVerifyEmail} from './verifyEmail'


 import { logout, dispatchClearLogout } from './logout';
import {  getHomeInfo, dispatchClearHomeInfo } from './home';
import { getCurrentAffairs, dispatchClearCurrentAffairs, getFullContentCurrentAffairs } from './currentAffairs';
import { getExams, dispatchClearExams } from './CourseAndLibraryExam';
import { getCourses, clearAllCoursesData } from './courseSubjects'
import { getLessonPlanner, clearLessonPlannerData } from './lessonPlanner';
import { getCourseMaterial, clearAllCourseMaterialData } from './courseContent';
import { getGetHtmlContent , dispatchClearGetHtmlContent} from './htmlContent';
import { getVimeoPlayerUrlWithId, clearVimeoPlayerWithId } from './vimeoPlayer';
import { userSignOut, userSignIn, restoreUserToken } from './authentication';
import { testAnalysis, clearTestAnalysisData } from './result';
import { getLibrarySubjects, clearLibrarySubjectsData } from './librarySubjects';
import { getLibraryTopicsBySubject, clearLibraryTopicsBySubjectData } from './topicLibraryDetails';
import { getLibraryContentInfo, clearLibraryContentData } from './libraryContent';
import { getPrivacyAndPolicy, clearPrivacyAndPolicyData } from './privacyAndPolicy';
import { getDiscalimer, clearDisclaimerData} from './disclaimer';
import { getAboutUs, clearAboutUsData } from './AboutUs';
import { getAppTermsAndConditions, clearAppTermsAndConditionsData } from './appTerms&cond';
import { getBookMarks, deleteBookMark, clearBookMarksData, addBookMark, clearDeleteBookMarkData, clearAddBookMarkData } from './bookmarkInfo';

import { getCurrentAffairsListForPagination, dispatchClearGetCurrentAffairsListForPagination  } from './currentAffairs/listOfCurrentAffairs';
 import {
  clearUpdateProfileData, updateProfile,
  clearGetUpdateProfile, getUpdateProfile,
  clearUploadProfileData,uploadProfilePic
// 
} from './editProfile';
import { verifyChangePhoneNumber,clearVerifyChangePhoneNumber } from './changePhone/verifyChangeNo';
import { checkoutCreateTest, clearAllPaymentForCreateTestData } from './payment';
import { getGetJwPlayerSourceFiles , clearGetJwPlayerSourceFiles } from './jwPlayer/index';
import { clearAllTestsData, getAllTestsInfo } from './getAllTestInfo'
import { baseUrl } from './constants/apiConstants';



axios.interceptors.response.use(function (response) {
  // console.log(response, 'axios success');
   return response;
 }, function (error) {   
  //  console.log(error.response, 'axios error response')
   if(error?.response?.data?.message == "Unauthorized") return window.location.pathname = '/';
   if(error.response && error.response.status === 502) alert('server error, please try again after some time');
   return Promise.reject(error);
 });

export {
    login,
    dispatchClearLoginInfo,
    // baseUrl,
    // getAppVersion,
    // clearAppVersion,
    registration,
    dispatchClearRegistation,
    // incrementBy,
    // test,
    // fetchAppVersion,
    dispatchClearOtp, 
    verifyOtp,
    clearUserNameVerify,
    userNameVerify,
    getTestSeriesList, 
    clearTestSeriesList,
    getTestSeriesTestList,
    clearTestSeriesTestList,
    getSingleTestInfo,
    clearSingleTestInfoData,
    getTestTermsAndConditions,
    clearTestTermsAndConditionsData,
    clearTest,
    setInitialStartTimeStamp,
    timeSpend,
    changeQuestion,
    selectedAnswers,
    getTest,
    markedQuestions,
    submitTest, clearSubmitTestData,
    dispatchClearHomeInfo,
    getHomeInfo,
    getCurrentAffairs, 
    dispatchClearCurrentAffairs,
    getExams, 
    dispatchClearExams,
    getCourses,
    clearAllCoursesData,
    getLessonPlanner, 
    clearLessonPlannerData,
    getCourseMaterial, 
    clearAllCourseMaterialData,
    getGetHtmlContent , 
    dispatchClearGetHtmlContent,
    getVimeoPlayerUrlWithId, 
    clearVimeoPlayerWithId,
    // userSignOut, 
    // userSignIn, 
    // restoreUserToken,
    clearTestAnalysisData,
    testAnalysis,
    getLibrarySubjects, 
    clearLibrarySubjectsData,
    getLibraryTopicsBySubject, 
    clearLibraryTopicsBySubjectData,
    getLibraryContentInfo, 
    clearLibraryContentData,
    verifyEmail, 
    clearVerifyEmail,
    getPrivacyAndPolicy, 
    clearPrivacyAndPolicyData,
    getDiscalimer, 
    clearDisclaimerData,
    getAboutUs, 
    clearAboutUsData,
    getAppTermsAndConditions, 
    clearAppTermsAndConditionsData,
    logout, 
    dispatchClearLogout,
    getBookMarks, 
    deleteBookMark, 
    clearBookMarksData, 
    addBookMark,
    getFullContentCurrentAffairs,
    clearDeleteBookMarkData,
    getCurrentAffairsListForPagination, 
    dispatchClearGetCurrentAffairsListForPagination,
    dispatchClearRegistrationOtpVerify, 
    verifyOtpForRegistration,
    clearAddBookMarkData,
    clearUpdateProfileData, updateProfile,
    clearGetUpdateProfile, getUpdateProfile,
    clearUploadProfileData,
    changePhoneNumber, 
    clearChangePhoneNumber,
    lostPhone, clearLostPhone,
    verifyChangePhoneNumber,
    clearVerifyChangePhoneNumber,
    uploadProfilePic,
    checkoutCreateTest, 
    clearAllPaymentForCreateTestData,
    getGetJwPlayerSourceFiles , 
    clearGetJwPlayerSourceFiles,
    clearAllTestsData, 
    getAllTestsInfo 
}